import * as s from "./website-black-guide-nav.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {isMobile} from "../../../../../../../sedestral/framework/utilities/IsMobile";
import {IWebsitePostCategoryModel} from "../../../../../../../models/website/posts/IWebsitePostCategoryModel";
import {Resources} from "../../../../../../../resources/Resources";
import {Network} from "../../../../../../../network/Network";
import {WebsiteGuideParams} from "../types/WebsiteGuideParams";

export class WebsiteBlackGuideNavComponent extends Component {
    public categories: IWebsitePostCategoryModel[];

    public categoriesContainer: Component;
    public postEntries: { route: string, entry: Component }[];

    constructor(categories: IWebsitePostCategoryModel[]) {
        super();
        this.categories = categories;
        this.postEntries = [];

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackGuideNav}">
                <div class="${s.scroll}">
                    <div class="${s.guides}">
                        ${Resources.t("words.ourGuides")}
                    </div>
                    <div class="${s.categories}"></div>
                </div>
            </div>
        `;
    }

    commit() {
        this.categoriesContainer = this.el(s.categories);

        this.categories
            .forEach(category => this.renderCategory(category));

        if (!isMobile()) {
            this.onResize(() => {
                this.setStyle(`height: ${window.innerHeight}px;`);
            });
            this.el(s.scroll).scrollable();
        }

        Network.router.pages.onPopState(this, () => this.updateEntries());

        super.commit();
    }

    renderCategory(category: IWebsitePostCategoryModel) {
        //language=HTML
        let categoryContainer = this.categoriesContainer.append(`
            <div itemscope itemtype="https://schema.org/ItemList" aria-label="${category.name}" class="${s.category}">
                <div class="${s.head}">
                    <div class="${s.collapse}">
                        <div class="${s.icon}"></div>
                    </div>
                    <div itemprop="name" class="${s.title}">
                        ${category.name}
                    </div>
                </div>
                <meta itemprop="numberOfItems" content="${category.posts.length}" />
                <ul class="${s.posts}"></ul>
            </div>
        `);

        let postsContainer = categoryContainer.el(s.posts);
        let collapseButton = categoryContainer.el(s.collapse);
        collapseButton.onClick(() => {
            if (categoryContainer.hasClass(s.collapsed)) {
                categoryContainer.removeClass(s.collapsed);
            } else {
                categoryContainer.addClass(s.collapsed);
            }
        });

        category.posts.forEach((post, index) => {
            //language=HTML
            let postEntry = postsContainer.append(`
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" ${post.route == Network.router.pages.getParam(WebsiteGuideParams.BASE) ? `class="${s.selected}` : ``}">
                <meta itemprop="position" content="${index + 1}" />
                <a itemprop="url" href="${Network.router.pages.getUrlWithPath(`guide/${post.route}`)}">
                    <div class="${s.badge}"></div>
                    <div itemprop="name">${post.shortTitle}</div>
                </a>
                </li>
            `, "li");

            this.postEntries.push({route: post.route, entry: postEntry});
        });
    }

    updateEntries() {
        this.postEntries.forEach(entry => {
            entry.entry.removeClass(s.selected);

            if (entry.route == Network.router.pages.getParam(WebsiteGuideParams.BASE))
                entry.entry.addClass(s.selected);
        });
    }

}